import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { HomeComponent } from './home/home.component';
import { LocationsComponent } from './locations.component';
import { SearchResultsComponent } from './search-results/search-results.component';
import { LocationDetailsComponent } from './location-details/location-details.component';

const routes: Routes = [
  {
    path: '', component: LocationsComponent, children: [
      { path: '', component: HomeComponent, },
      { path: 'search', component: SearchResultsComponent, data: { title: 'Search' } },
      { path: 'buscar', component: SearchResultsComponent, data: { title: 'Buscar' }},
      { path: ':id', component: LocationDetailsComponent }]
  }];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class LocationsRoutingModule { }
